// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Badge_iconContainer__ujgib","image":"Badge_image__3bC-3","text":"Badge_text__24KIe","link":"Badge_link__3pnTN"};